export default __webpack_public_path__ + "static/media/home-travel-agency-slider-img03.22d4149f.jpg";